// The PDF.js viewer highlights links in a PDF with a yellow box on hover. The theme removes it; links keep the
// pointer cursor. The viewer runs in an iframe without any hook to add styles, so the theme adds them to the
// (same-origin) viewer document instead. Keyboard focus and the forced-colors styles of PDF.js are left alone.
const STYLE_ID = 'vrgz-pdfjs-viewer-styles';

const VIEWER_CSS = `
  .annotationLayer :is(.linkAnnotation, .buttonWidgetAnnotation.pushButton):not(.hasBorder) > a:hover,
  .annotationLayer .linkAnnotation.hasBorder:hover {
    background-color: transparent;
  }
`;

const injectStyles = iframe => {
  // Null for a cross-origin viewer, which cannot be styled.
  const viewerDocument = iframe.contentDocument;

  if (!viewerDocument?.head || viewerDocument.getElementById( STYLE_ID )) {
    return;
  }

  const style = viewerDocument.createElement( 'style' );
  style.id = STYLE_ID;
  style.textContent = VIEWER_CSS;
  viewerDocument.head.append( style );
};

const pdfViewerStyles = iframes => {
  [...iframes].forEach( iframe => {
    // The iframes are lazy loaded, so most of them load after this script has run.
    iframe.addEventListener( 'load', () => injectStyles( iframe ) );

    if ('complete' === iframe.contentDocument?.readyState && 'about:blank' !== iframe.contentWindow?.location.href) {
      injectStyles( iframe );
    }
  } );
};

export default pdfViewerStyles;
